var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconSubaccountsLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconSubaccounts",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1242.24 0v564.706h-225.77v301.101h677.648v489.487H1920V1920h-564.819v-564.706h225.995V978.861h-564.705v376.433h225.769V1920H677.647v-564.706H903.53V978.861H338.711v376.433h225.995V1920H0v-564.706h225.77V865.807h677.76V564.706H677.646V0h564.593Zm564.819 1468.348h-338.937v338.824h338.937v-338.824Zm-677.647 0H790.588v338.824h338.824v-338.824Zm-677.647 0H112.94v338.824h338.824v-338.824Zm677.647-1355.407H790.588v338.937h338.824V112.94Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconSubaccountsLine.glyphName = 'subaccounts';
IconSubaccountsLine.variant = 'Line';
IconSubaccountsLine.displayName = 'IconSubaccountsLine';
IconSubaccountsLine.allowedProps = [...SVGIcon.allowedProps];
export default IconSubaccountsLine;
export { IconSubaccountsLine };